export default "__VITE_PUBLIC_ASSET__268a8978__"